import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ITepEntryPass } from 'types/tep';
import { chevronDown } from 'assets/icons';
import Input from 'components/molecules/input';
import { DevicesModal } from '../modals/devices-modal';
import { actions } from 'core/redux/api/veta/tep/entry-passes';
import { entryPassesSelector } from 'core/redux/selectors/tep';

import styles from './styles.module.css';

interface IUriProps {
  entryPass: ITepEntryPass;
}

export const TepDeviceUriCell: FC<IUriProps> = ({ entryPass }) => {
  const dispatch = useDispatch();

  const { intent, selected } = useSelector(entryPassesSelector);

  const [isModal, setModal] = useState<boolean>(false);

  const isEdit = intent === 'edit' && entryPass.id === selected?.id;

  const closeModal = () => setModal(false);

  const openModal = () => setModal(true);

  const selectDevice = (uris: string[]) => {
    if (selected && uris?.length) {
      const updatedSelected = { ...selected, device: { ...selected.device, uri: uris[0] } };

      dispatch(actions.select({ entryPass: updatedSelected }));
      closeModal();
    }
  };

  return (
    <>
      {isEdit ? (
        <div className={styles.wrapper}>
          <Input value={selected?.device?.uri || ''} icon={chevronDown} onClick={openModal} readOnly />
        </div>
      ) : (
        <div>{entryPass.device.uri}</div>
      )}
      {isModal && (
        <DevicesModal
          isSingle
          uris={selected ? [selected.device.uri] : []}
          closeModal={closeModal}
          onSubmit={selectDevice}
        />
      )}
    </>
  );
};
